
import { tap, switchMap, distinctUntilChanged, debounceTime, map } from 'rxjs/operators';
// Angular
import { Component, AfterViewInit, EventEmitter, Output, Input } from '@angular/core';

import _isString from 'lodash-es/isString';
import _cloneDeep from 'lodash-es/cloneDeep';

// RXJS
import { Observable } from 'rxjs';

// Afidium
import { GenericField, IGenericField } from '../generic-field';
import { SearchService } from './search.service';

interface IDgeo {
    dgeo_id_geoentity: number;
    dgeo_name: string;
    dgeo_code_iata: string;
    dgeo_functions: string;
    dgeo_country_code: string;
    dgeo_country_name: string;
    cityref_id_geoentity: number;
    cityref_name: string;
    cityref_code_iata: string;
    dgeo_subdivision_code: number;
    search_column: string;
}

/**
 * @deprecated use autocomplete instead
 */
@Component({
    selector: 'autocomplete-field',
    templateUrl: './autocomplete-field.component.html',
    styleUrls: [],
})
export class AutoCompleteFieldComponent extends GenericField implements IGenericField, AfterViewInit {
    @Output()
    public onValueSelect: EventEmitter<any> = new EventEmitter();
    public filteredList$: Observable<any[]>;

    @Input()
    public strict: boolean;

    public optionsDisplay: any;

    @Input()
    public itemLabel: string;


    @Input()
    public optionsApi: {
        debounceTime: number,
        api: string,
        format: string
    } = { debounceTime: 300, api: 'airportsGetter', format: 'location' };


    @Input()
    public filterData: {
        key: string,
        value: any,
        operator: string
    };
    private isFocus: boolean = false;


    constructor(private searchService: SearchService) {
        super();
    }



    public ngAfterViewInit(): void {
        this.filteredList$ = this.group.get(this.controlName)
            .valueChanges.pipe(
                map((data) => {
                    if (_isString(data)) {
                        return data;
                    } else {
                        return null;
                    }
                }),
                debounceTime(this.options.debounceTime),
                distinctUntilChanged(),
                switchMap((term: string) => {
                    return this.searchService.searchFormatFilter(this.optionsApi.api, term, this.optionsApi.format, this.filterData);
                }),
                tap(() => {
                    setTimeout(
                        () => {
                            if (!this.isFocus && _isString(this.group.get(this.controlName).value)) {
                                this.group.get(this.controlName).patchValue('');
                            }
                        },
                        50
                    );

                }));


    }

    public show() {
        this.autoField.show();
    }



    public onFocus($event) {
        super.onFocus($event);
        this.isFocus = true;

    }


    public onBlur($event) {
        super.onBlur($event);
        this.isFocus = false;
    }



    public valueSelected($event) {
        this.onValueSelect.emit($event);
    }

    public onKeyUp($event) {
        this.optionsDisplay = _cloneDeep(this.optionsDisplay);
    }

    //TODO? or not : show whole list if no query on click
}
